import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from 'components/core/Button';
import { SFIcon } from 'components/core/SFIcon';
import { GalleryImage } from './FacilityGallery';
import { IconText } from 'components/core/IconText';

import './GalleryModal.scss';

export const GalleryModal = ({
	images,
	currentIndex,
	onPrevious,
	onNext,
	onThumbnailClick,
}) => (
	<div className="facility-gallery-modal">
		<div className="facility-gallery-modal__image-container">
			<GalleryImage
				src={images[currentIndex].src}
				alt={images[currentIndex].alt}
				className="facility-gallery-modal__main-image"
			/>
			<div className="facility-gallery-modal__controls">
				<Button
					className={classNames('facility-gallery-modal__nav-btn', {
						'facility-gallery-modal__nav-btn--disabled':
							currentIndex === 0,
					})}
					onClick={onPrevious}
					disabled={currentIndex === 0}
					secondary
				>
					<SFIcon icon="chevron-left" />
				</Button>

				<span className="facility-gallery-modal__counter-text">
					{currentIndex + 1} / {images.length}
				</span>

				<Button
					className={classNames('facility-gallery-modal__nav-btn', {
						'facility-gallery-modal__nav-btn--disabled':
							currentIndex === images.length - 1,
					})}
					onClick={onNext}
					disabled={currentIndex === images.length - 1}
					secondary
				>
					<SFIcon icon="chevron-right" />
				</Button>
			</div>
		</div>
		<div className="facility-gallery-modal__thumbnails">
			{images.map((img, idx) => (
				<div
					key={`thumb-${idx}`}
					className={classNames('facility-gallery-modal__thumbnail', {
						'facility-gallery-modal__thumbnail--active':
							idx === currentIndex,
					})}
					onClick={() => onThumbnailClick(idx)}
				>
					<GalleryImage
						src={img.src}
						alt={img.alt}
						className="facility-gallery-modal__thumb-image"
					/>
				</div>
			))}
		</div>
		<div className="facility-gallery-modal__mobile-footer">
			<div className="facility-gallery-modal__mobile-footer-controls">
				<Button
					gray
					className={classNames('facility-gallery-modal__nav', {
						'facility-gallery-modal__nav--disabled':
							currentIndex === 0,
					})}
					onClick={onPrevious}
					aria-label="Previous image"
					disabled={currentIndex === 0}
				>
					<SFIcon
						icon="chevron-left"
						className="facility-gallery-modal__chevron"
					/>
					Prev
				</Button>
			</div>
			<div className="facility-gallery-modal__counter-text">
				{currentIndex + 1} / {images.length}
			</div>
			<div className="facility-gallery-modal__mobile-footer-controls">
				<Button
					gray
					className={classNames('facility-gallery-modal__nav', {
						'facility-gallery-modal__nav--disabled':
							currentIndex === images.length - 1,
					})}
					onClick={onNext}
					aria-label="Next image"
					disabled={currentIndex === images.length - 1}
				>
					Next
					<SFIcon
						icon="chevron-right"
						className="facility-gallery-modal__chevron"
					/>
				</Button>
			</div>
		</div>
	</div>
);

GalleryModal.propTypes = {
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string.isRequired,
			alt: PropTypes.string,
		})
	).isRequired,
	currentIndex: PropTypes.number.isRequired,
	onPrevious: PropTypes.func.isRequired,
	onNext: PropTypes.func.isRequired,
	onThumbnailClick: PropTypes.func.isRequired,
};
